import { normalize, schema } from 'normalizr';

export const FETCH_RELEASE_NOTES = 'FETCH_RELEASE_NOTES';
export const FETCH_RELEASE_NOTES_SUCCESS = 'FETCH_RELEASE_NOTES_SUCCESS';
export const RESET_RELEASE_NOTES = 'RESET_RELEASE_NOTES';

import { receiveGlobalMeta } from 'Actions/MetaActions';
import { setLastGlobalAction, setGlobalNotification, getFetchConfig } from 'Actions/GlobalMetaActions';
import { getLoadingBehavior, shouldNotUpdateState, updatePagesResult, fetchSuccess } from 'Actions/InfiniteScrollActions';
import { getPageSize } from 'Actions/UserSettingsActions';

const fetchReleaseNotes = (loadingBehavior) => {
	return {
		type: FETCH_RELEASE_NOTES,
		loadingBehavior
	};
};

const receiveReleaseNotes = (data,loadingBehavior) => {
	return {
		type: FETCH_RELEASE_NOTES_SUCCESS,
		data: data,
		loadingBehavior
	};
};

export const resetReleaseNotes = () => {
	return {
		type: RESET_RELEASE_NOTES
	};
};

const note = new schema.Entity( 'notes', {}, { idAttribute: 'n_id' } );

export const whatReleaseNotes = (pageNum,forceRefresh) => {

	return (dispatch,getState) => {

		const page = parseInt(pageNum),
			notesRequest = {
				page,
				forceRefresh
			},
			loadingBehavior = getLoadingBehavior(getState, null, "releaseNotes", page, forceRefresh);

		if ( shouldNotUpdateState(getState, notesRequest) ) {
			dispatch( updatePagesResult( pageNum || 1 ) );
			setLastGlobalAction('releaseNotes',notesRequest);
			return null;
		}

		dispatch( fetchReleaseNotes(loadingBehavior) );

		const state = getState(),
			page_size = dispatch( getPageSize() ),
			url = state.topifyPresets.ffUrl + 'm/getnotifications?v=3.0&ajax=1',
			config = dispatch( getFetchConfig() );

		return fetch(`${url}&pagesize=${page_size}&page=${page}`, config)
			.then( response => {
				if ( !response.ok) {
					try {
						response.json().then((json) => {
							setGlobalNotification( dispatch, json, response );
						});
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}
					return null;
				} else {
					return response.json();
				}
			})
			.then( json => {
				if ( !json ) { return; }

				let preNormalized = {
						notes: ( json.notifications_topify || { data: [] } ).data.map( e => {
							return Object.assign( e, { page: parseInt( page ) || 1 } );
						} )
					},
					other = {
						page: page || 1
					},
					result = Object.assign(
						{},
						other,
						{},
						normalize( preNormalized,
							{
								notes: [ note ],
							}
						)
					);

				let totalPages = Math.ceil( json.notifications_topify.total / page_size );

				dispatch( receiveGlobalMeta( null, "Topify Release Notes" ) );
				dispatch( fetchSuccess( null, "releaseNotes", page, totalPages, loadingBehavior ) );
				dispatch( receiveReleaseNotes( result, loadingBehavior ) );
			})
			.then(() => {
				setLastGlobalAction('releaseNotes',notesRequest);
			})
			.catch( (error) => {
				setGlobalNotification( dispatch, {}, error );
			});
	};
};


// WEBPACK FOOTER //
// ./src/actions/ReleaseNotesActions.js